import { For } from 'solid-js';
import { Logo } from './Logo';
import { contacts, disclaimers, legalLinks } from '~/data/config';
import './Footer.css';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer class="footer">
      <div class="container footer__inner">
        <div class="footer__brand">
          <Logo />
          <p class="footer__about">
            Поставка двигателей, КПП, мостов и редких запчастей для&nbsp;грузовиков и&nbsp;спецтехники по&nbsp;всей России.
          </p>
        </div>

        <div class="footer__col">
          <span class="footer__title">Каталог</span>
          <a href="/#supplies">Что поставляем</a>
          <a href="/#how">Как работаем</a>
          <a href="/#lead">Подбор агрегата</a>
        </div>

        <div class="footer__col">
          <span class="footer__title">Контакты</span>
          <a href={`tel:${contacts.phones[0].tel}`}>{contacts.phones[0].value}</a>
          <a href={`tel:${contacts.phones[1].tel}`}>{contacts.phones[1].value}</a>
          <a href={`mailto:${contacts.email}`}>{contacts.email}</a>
        </div>

        <div class="footer__col footer__col--wide">
          <span class="footer__title">Адрес</span>
          <p>{contacts.address.full}</p>
          <p>{contacts.workingHours}</p>
        </div>
      </div>

      <div class="container footer__legal">
        <ul class="footer__legal-links" aria-label="Юридические документы">
          <For each={legalLinks}>
            {(link) => (
              <li>
                <a href={link.href}>{link.label}</a>
              </li>
            )}
          </For>
        </ul>
        <p class="footer__offer">{disclaimers.publicOffer}</p>
      </div>

      <div class="container footer__bottom">
        <span class="footer__copyright">
          © {year} {contacts.legalName}. Все права защищены.
        </span>
        <a
          class="footer__credit"
          href="https://one-sol.ru"
          target="_blank"
          rel="noopener noreferrer"
        >
          Создание и&nbsp;продвижение сайта —{' '}
          <span class="footer__credit-brand">one sol</span>
          <span class="footer__credit-arrow" aria-hidden="true">↗</span>
        </a>
      </div>
    </footer>
  );
}
